export const NAME = 'contactrequest';

export const REQUEST_CONTACT_REQUEST_REASON = 'REQUEST_CONTACT_REQUEST_REASON';
export const RECEIVE_CONTACT_REQUEST_REASON = 'RECEIVE_CONTACT_REQUEST_REASON';
export const FAILURE_CONTACT_REQUEST_REASON = 'FAILURE_CONTACT_REQUEST_REASON';

export const REQUEST_FORM_SUBMIT_CONTACT_REQUEST = 'REQUEST_FORM_SUBMIT_CONTACT_REQUEST';
export const SUCCESS_FORM_SUBMIT_CONTACT_REQUEST = 'SUCCESS_FORM_SUBMIT_CONTACT_REQUEST';
export const FAILURE_FORM_SUBMIT_CONTACT_REQUEST = 'FAILURE_FORM_SUBMIT_CONTACT_REQUEST';

export const RESET_FORM_SUBMIT_CONTACT_REQUEST = 'RESET_FORM_SUBMIT_CONTACT_REQUEST';

// Request reasons visibility
export const ALL = 'ALL';
export const LOGGED = 'LOGGED';

// Purchase date period
export const MIN_DAYS = 7;
export const MAX_DAYS = 120;
export const MAX_MONTH = 4;



// WEBPACK FOOTER //
// ./src/services/contactrequest/constants.js